module.exports = __webpack_public_path__ + "static/media/logo.e2c9fdd2.svg";